import React, {useState} from "react";
import {GridColDef, GridRowParams} from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionIcon from "@mui/icons-material/Description";
import ExtGridWrapper from "../../../../components/grid/ExtGridWrapper";
import {ActionButtonType, EnabledPolicy, GridAction} from "../../../../components/grid/GridAction";
import {PersistentStateId} from "../../../../store/common/Grid";
import {t} from "../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../CommonTranslationKey";
import {UserGroupDto} from "../../../../common/apis/usergroup/UserGroupDto";
import {useFindAllUserGroupsQuery} from "./UserGroupQuery";
import {ButtonId} from "./ButtonId";
import {UserGroupsTranslationKey} from "./UserGroupsTranslationKey";
import UserGroupDetailDialog from "./UserGroupDetailDialog";
import UserGroupCreateDialog from "./UserGroupCreateDialog";
import UserGroupDeleteDialog from "./UserGroupDeleteDialog";

export default function UserGroupsGrid() {
    const {data: userGroups} = useFindAllUserGroupsQuery();

    const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>();
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const selectedGroup = userGroups?.find(g => g.id === selectedGroupId);

    function onRowClick(params: GridRowParams) {
        setSelectedGroupId(params.row.id);
    }

    function onGroupCreated(group: UserGroupDto) {
        setCreateDialogOpen(false);
        setSelectedGroupId(group.id);
        setDetailDialogOpen(true);
    }

    const columns: GridColDef<UserGroupDto>[] = [
        {field: 'name', headerName: t(CommonTranslationKey.TITLE), width: 300},
        {field: 'description', headerName: t(CommonTranslationKey.DESCRIPTION), width: 500},
    ];

    return (
        <>
            {selectedGroup &&
                <UserGroupDetailDialog
                    opened={detailDialogOpen}
                    onClose={() => setDetailDialogOpen(false)}
                    userGroupId={selectedGroup.id}
                />
            }
            {createDialogOpen &&
                <UserGroupCreateDialog
                    onClosed={() => setCreateDialogOpen(false)}
                    onGroupCreated={onGroupCreated}
                />
            }
            {selectedGroupId &&
                <UserGroupDeleteDialog
                    open={deleteDialogOpen}
                    groupId={selectedGroupId}
                    onClose={() => setDeleteDialogOpen(false)}
                    onDeleted={() => setSelectedGroupId(undefined)}
                />
            }
            <ExtGridWrapper
                columns={columns}
                rows={userGroups ?? []}
                rowCount={userGroups?.length ?? 0}
                getRowId={row => row.id}
                onRowClick={(params) => onRowClick(params)}
                onRowDoubleClick={() => setDetailDialogOpen(true)}
                actions={[
                    GridAction.buttonBuilder(ButtonId.GROUP_DETAIL, ActionButtonType.IMMEDIATE, t(UserGroupsTranslationKey.GROUP_DETAIL),
                        <DescriptionIcon/>)
                        .enabledPolicy(EnabledPolicy.WHEN_EXACTLY_ONE_SELECTED)
                        .onClick(() => setDetailDialogOpen(true))
                        .build(),
                    GridAction.buttonBuilder(ButtonId.ADD_GROUP, ActionButtonType.IMMEDIATE, t(UserGroupsTranslationKey.ADD_GROUP),
                        <AddIcon/>)
                        .enabledPolicy(EnabledPolicy.ALWAYS)
                        .onClick(() => setCreateDialogOpen(true))
                        .build(),
                    GridAction.buttonBuilder(ButtonId.DELETE_GROUP, ActionButtonType.IMMEDIATE, t(UserGroupsTranslationKey.DELETE_GROUP),
                        <DeleteIcon/>)
                        .enabledPolicy(EnabledPolicy.WHEN_EXACTLY_ONE_SELECTED)
                        .onClick(() => setDeleteDialogOpen(true))
                        .build(),
                ]}
                peristentStateId={PersistentStateId.USER_GROUPS_PAGE_GRID}
                resourceId={"userGroups"}
            />
        </>
    );
}
